import CryptoJS from "crypto-js";
const secretKey = process.env.REACT_APP_CODE_KEY;
// Encrypt
export const encodeHashData = (data) => {
  try {
    let encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      secretKey
    ).toString();
    return encryptedData;
  } catch (error) {
    console.error("Encryption error:", error);
    throw error;
  }
};

// Decrypt
export const decodeHashData = (encryptedData) => {
  try {
    if (encryptedData) {
      let bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
      let decryptedString = bytes.toString(CryptoJS.enc.Utf8);

      // If the decrypted string is empty, return null
      if (!decryptedString) return null;

      try {
        // Try to parse as JSON
        return JSON.parse(decryptedString);
      } catch (parseError) {
        // If it's not valid JSON, return the string as is
        console.log("Not valid JSON, returning as string:", decryptedString);
        return decryptedString;
      }
    } else return;
  } catch (error) {
    console.error("Decryption error:", error);
    // Return null instead of throwing to avoid breaking the application
    return null;
  }
};
